export default [
    {
        path: '/supervision/refrigeration',
        name: 'refrigeration',
        meta: {
            layout: 'session'
        },
        component: () => import('VIEWS/supervision/Refrigeration.vue')
    }
]